import OaApiService from './OaApiService';

export default class AgentService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.getByIdUrl = '/AgentREST/id';
    this.getByKeyUrl = '/AgentREST/key';
    this.updateUrl = '/AgentREST';
  }

  getByAuthToken(token) {
    return this.get('/AgentREST/get-agent-by-auth-token', { token });
  }

  getAgentExperiments(agentKey) {
    return this.get('/AgentREST/agent-splittest-variations', {}, agentKey);
  }

  getQA(agentId) {
    return new Promise((resolve, reject) => {
      this.get('/AgentREST/qa', {}, agentId)
        .then((qa) => {
          resolve(qa);
        })
        .catch((error) => {
          // This endpoint returns false when there is no entry exists
          // We don't want to throw an error in that case but expect an empty object
          if (error === 'Agent QA record not found') {
            resolve({});
          } else {
            reject(error);
          }
        });
    });
  }

  createAuthToken(agentKey) {
    return this.get('/AgentREST/create-agent-auth-token', {}, agentKey);
  }

  // updateById(data, agentId) {
  //   const updateData = {
  //     formname: 'edit-agent-form',
  //   };
  //   return this.put('/AgentREST/update-agent-qa', Object.assign({}, data, updateData), agentId);
  // }

  updateQA(data) {
    return this.post('/AgentREST', data);
  }

  toggleAgentDigest(agentKey) {
    return this.put('/AgentREST/toggle-agent-digest-enabled', null, agentKey);
  }
}
